const serviceWorkerPath = new URL(`./sw.ts`, import.meta.url);
const serviceWorkerFilename = (serviceWorkerPath + '').split('/').pop();
const pathname = window.location.pathname;
const isDev = process.env.NODE_ENV === "development";
const isActivationPage = pathname.includes("/activation");

const fullPath = pathname[pathname.length - 1] === '/' ? pathname.slice(0, pathname.length - 1) : pathname;
const isSwInstalled = localStorage.getItem(`sw-installed-${process.env.SW_CACHE_NAME}`) === "true";

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || window.top !== window.self || !serviceWorkerFilename || navigator.serviceWorker.controller || isDev || isActivationPage) {
    // don't instantiate service worker:
    // [1] if service worker isn't supported
    // [2] in iframes
    // [3] if there is no service worker file
    // [4] if there is already a sw instance
    // [5] in development mode
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register(
      fullPath + "/" + serviceWorkerFilename,
      {
        // type: "module",
        scope: fullPath + "/"
      }
    )

    setTimeout(() => {
      if (registration.active && isSwInstalled) {
        return;
      }

      // reload the page if this is the first time the service worker is installed
      // record in localStorage to prevent multiple reloads
      localStorage.setItem(`sw-installed-${process.env.SW_CACHE_NAME}`, "true");
      window.location.reload();
    }, 1000);
  } catch (error) {
    console.error(`Registration failed with ${error}`);
  }
}
